module.exports = __webpack_public_path__ + "img/r.2793ea0f.jpg";